(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eh-quote-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
 const add = event.target.closest('.eh-add-item');
 const remove = event.target.closest('.eh-remove-item');
 if (!add && !remove) return;
 const section = event.target.closest('.eh-quote');
 if (!section) return;
 if (add) {
  const row = section.querySelector('[data-item-row][hidden]');
  if (row) { row.hidden = false; row.querySelectorAll('input').forEach(input => input.disabled = false); row.querySelector('input').focus(); }
 }
 if (remove) {
  const row = remove.closest('[data-item-row]');
  row.hidden = true;
  row.querySelectorAll('input').forEach(input => { input.disabled = true; input.value = ''; input.required = false; });
 }
 const addButton = section.querySelector('.eh-add-item');
 addButton.disabled = !section.querySelector('[data-item-row][hidden]');
 const status = section.querySelector('.eh-row-status');
 status.textContent = section.querySelectorAll('[data-item-row]:not([hidden])').length + ' ' + status.dataset.statusLabel;
 if (remove) addButton.focus();
});
document.addEventListener('input', function(event) {
 const row = event.target.closest('[data-item-row]');
 if (!row || row.dataset.itemRow === '1') return;
 const inputs = Array.from(row.querySelectorAll('input'));
 const active = inputs.some(input => input.value.trim() !== '');
 inputs.forEach(input => input.required = active);
});

  } catch(e) { console.error(e); }
})();
})();
